import Minus from 'components/ReusableComponents/Icons/Minus'
import Plus from 'components/ReusableComponents/Icons/Plus'
import { useEffect, useRef, useState } from 'react'

import styles from './MultiSelectDropdown.module.scss'

const MultiSelectDropdown = ({
  value,
  options,
  onChangeValue,
  itemName,
  itemNamePlural,
  className,
  hasUnselectButton = false,
  zeroResultText = null
}) => {
  const [isOpen, setOpen] = useState(false)
  const [pmsList, setPmsList] = useState()

  function handleCheckboxChange(e) {
    if (e.target.checked) {
      onChangeValue([...value, e.target.value])
    } else {
      onChangeValue([...value].filter(v => v !== e.target.value))
    }
  }

  const node = useRef()

  const handleClickOutside = e => {
    if (node.current.contains(e.target)) {
      return
    }
    setOpen(false)
  }

  useEffect(() => {
    setPmsList(Object.keys(options))
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen, options])

  return (
    <div className={styles.wrapper} ref={node}>
      <div className={styles.dropdownHolder} onClick={() => setOpen(!isOpen)}>
        <div className={[styles.select, className].join(' ')}>
          {value.length === 0 && (zeroResultText || `0 ${itemName}`)}
          {value.length === 1 && options[value[0]]}
          {value.length > 1 && `${value.length} ${itemNamePlural || itemName}`}
        </div>
      </div>
      {isOpen && (
        <div className={styles.dialog}>
          {Object.keys(options)
            .sort((a, b) => options[b] - options[a])
            .map(v => (
              <Value
                isChecked={value.includes(v)}
                key={v}
                value={v}
                text={options[v]}
                onChange={handleCheckboxChange}
              />
            ))}
          {pmsList.length > value.length && (
            <button className={styles.checkAll} onClick={() => onChangeValue(pmsList)}>
              <Plus /> Check all
            </button>
          )}
          {hasUnselectButton && value.length > 1 && (
            <button className={styles.uncheckAll} onClick={() => onChangeValue([])}>
              <Minus /> Uncheck all
            </button>
          )}
        </div>
      )}
    </div>
  )
}

const Value = ({ value, onChange, isChecked, text }) => (
  <div className={isChecked ? styles.rateActive : styles.rate}>
    <label className={styles.rateName}>
      <input type="checkbox" onChange={onChange} checked={isChecked} value={value} />
      {text}
    </label>
  </div>
)

export default MultiSelectDropdown
